import React from "react";
import { NavLink } from "react-router-dom";

import styles from "./SidebarMenu.module.css";

const SidebarMenu = ({
  items,
  activeItem,
  iconSize = 16,
  className,
  testId,
}) => {
  return (
    <nav className={`${styles.container} ${className || ""}`} data-testid={testId}>
      {items.map((item) => {
        const iconElement = item.Icon ? (
          <item.Icon
            size={iconSize}
            className={styles.icon}
            aria-hidden
          />
        ) : item.iconSrc ? (
          <img
            src={item.iconSrc}
            alt=""
            width={iconSize}
            height={iconSize}
            className={styles.icon}
          />
        ) : null;

        if (item.to) {
          return (
            <NavLink
              key={item.label}
              to={item.to}
              className={({ isActive }) =>
                `${styles.item} ${isActive ? styles.itemActive : ""}`
              }
            >
              {iconElement}
              {item.label}
            </NavLink>
          );
        }

        const isActive = item.label === activeItem;
        const isDisabled = item.disabled;

        return (
          <button
            key={item.label}
            type="button"
            className={`${styles.item} ${isActive ? styles.itemActive : ""} ${isDisabled ? styles.itemDisabled : ""}`}
            onClick={isDisabled ? undefined : item.onClick}
            disabled={isDisabled}
          >
            {iconElement}
            {item.label}
          </button>
        );
      })}
    </nav>
  );
};

export { SidebarMenu };
